// Drop function
var dropToggle = function (button, buttonList) {
  // Get element to toggle
  var drop = document.querySelector(button.dataset.toggle)

  button.addEventListener('click', function (event) {
    // Prevent links from leaving the page
    event.preventDefault()

    var isOpen = drop.classList.contains('is-active')

    var buttonListLength = buttonList.length

    for (var i = 0; i < buttonListLength; i++) {
      var dropCurrent = document.querySelector(buttonList[i].dataset.toggle)

      buttonList[i].classList.remove('is-active')
      dropCurrent.classList.remove('is-active')
      dropCurrent.setAttribute('aria-hidden', true)
    }

    if (!isOpen) {
      // Add `is-active` class to button and dropdown
      button.classList.add('is-active')
      button.setAttribute('aria-expanded', true)
      drop.classList.add('is-active')

      // Set `aria-hidden` to `false` for dropdown
      drop.setAttribute('aria-hidden', false)
    } else {
      button.setAttribute('aria-expanded', false)
    }
  })
}

// Mobile navigation
var toggleNavButton = document.querySelectorAll('.js-toggle-nav')
var toggleNavButtonLength = toggleNavButton.length

for (var i = 0; i < toggleNavButtonLength; i++) {
  dropToggle(toggleNavButton[i], toggleNavButton)
}

var navbar = document.querySelector('.js-navbar')

// Set initial navbar `aria-hidden` state
if (navbar && window.matchMedia('(max-width: 767px)').matches) {
  navbar.setAttribute('aria-hidden', 'true')
}

// Navigation dropdown
var dropButtons = document.querySelectorAll('.js-navbar-drop-button')
var dropButtonsLength = dropButtons.length

// Iterate over all buttons
for (var j = 0; j < dropButtonsLength; j++) {
  dropToggle(dropButtons[j], dropButtons)
}



// WEBPACK FOOTER //
// ./src/components/navbar/scripts.js